<div class="organization-members-result">
  <div class="organization-members-result__filters flex-row start-center gap-8">
    <ui-search
      class="organization-members-result__search"
      [placeholder]="'USERS.PLACEHOLDERS.SEARCH' | translate"
      [searchQuery]="searchQuery()"
      (onInput)="onSearchQuery($event)"
    ></ui-search>

    <mat-select
      class="ui-selector organization-members-result__permissions"
      panelClass="selector-option-full-width"
      [formControl]="groupFilterControl"
      [multiple]="true"
      [placeholder]="'USERS.PLACEHOLDERS.PERMISSIONS' | translate"
    >
      @for (group of permissionGroups(); track group.id) {
        <mat-option class="organization-members-result__permission-option" [value]="group.id">
          {{ group.name }}
        </mat-option>
      }
    </mat-select>
  </div>

  @if (groupFilterControl.value.length) {
    <div class="organization-members-result__chips flex-row">
      @for (groupId of groupFilterControl.value; track groupId) {
        <ui-filter-chip
          [title]="permissionGroupNamesById()[groupId]"
          (removeClicked)="removeGroupFilter(groupId)"
        ></ui-filter-chip>
      }
    </div>
  }

  @if (members().length) {
    @if (tableConfig(); as config) {
      <div class="table-wrapper">
        <ui-dataset-table
          #membersTable
          [data]="members()"
          [config]="config"
          [sortState]="sortState()"
          (selectionChange)="onSelectionChange($event)"
          (sortChange)="onSortChange($event)"
          (rowAction)="onRowAction($event)"
        ></ui-dataset-table>
      </div>
    }
  } @else {
    <ui-no-data
      class="organization-members-result__empty"
      [imgSrc]="noData.imgSrc"
      [description]="noData.description | translate"
    ></ui-no-data>
  }

  @if (selectedMembersCount()) {
    <ui-selected-items-snackbar
      [counter]="selectedMembersCount()"
      [selectedText]="'USERS.CONFIRMATIONS.FORCE_LOGOUT_BULK.USERS_SELECTED'"
      (selectAll)="onSelectAll()"
      (clearAll)="clearSelection()"
    >
      <div class="flex-row start-center gap-8">
        @if (canForceLogoutUser()) {
          <ui-button
            type="secondary"
            iconClass="ui-icon-logout"
            [text]="'USERS.CONFIRMATIONS.FORCE_LOGOUT_BULK.TITLE' | translate"
            (clickAction)="forceLogoutForSelectedMembers()"
          ></ui-button>
        }
        @if (canForcePasswordResetUser()) {
          <ui-button
            type="secondary"
            iconClass="ui-icon-lock"
            [text]="'USERS.CONFIRMATIONS.FORCE_RESET_PASSWORD_SINGLE.TITLE' | translate"
            (clickAction)="forceResetPasswordForSelectedMembers()"
          ></ui-button>
        }
      </div>
    </ui-selected-items-snackbar>
  }

  <!-- CELL TEMPLATES -->
  <ng-template #nameCell let-row>
    @if (row.firstname || row.lastname) {
      {{ row.firstname }} {{ row.lastname }}
    } @else {
      &mdash;
    }
  </ng-template>

  <ng-template #emailCell let-row>
    {{ row.email }}
  </ng-template>

  <ng-template #permissionsCell let-row>
    @if (permissionNames(row.groupIds); as names) {
      <ui-truncated-html class="organization-members-result__permission-names">
        {{ names }}
      </ui-truncated-html>
    } @else {
      &mdash;
    }
  </ng-template>

  <ng-template #lastLoginCell let-row>
    @if (row.lastLogin) {
      <ui-user-settings-date [date]="row.lastLogin | unixTs"></ui-user-settings-date>
    } @else {
      &mdash;
    }
  </ng-template>
</div>
